import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function SizeReco(props) {
    return (
        <SvgIcon {...props}>
            <path fill="#353535" d="M20.3 5.5c0 .2-.1.3-.3.5l-3.9 3.9-9.6 9.6c-.2.2-.4.3-.6.3-.1 0-.3-.1-.4-.2L1 15.1c-.3-.3-.3-.7 0-1l3.9-3.9L14.6.5c.2-.2.4-.3.7-.3.1 0 .3.1.4.2l4.5 4.5c0 .2.1.4.1.6zm-1.5 0L15 1.7l-1.4 1.4c.1.1.2.1.2.2l.9.9c.3.3.3.6 0 .9-.2.2-.6.3-.9 0l-.4-.4c-.1-.2-.4-.5-.6-.7l-.8.8.8.8L14.2 7c.3.3.3.8-.1 1-.3 0-.6 0-.8-.3l-2-2-.1-.1-.8.8s.1.1.2.1l1 1c.2.2.2.4.2.7-.1.2-.2.4-.5.4-.2 0-.4-.1-.6-.2L9.6 7.3c-.3.2-.6.4-.8.7 0 0 .1.1.2.1l1 1c.2.2.3.5.1.7-.2.4-.7.5-1 .1l-1-1-.1-.1c-.3.3-.6.5-.8.8 0 0 .1.1.2.1.6.7 1.2 1.3 1.9 1.9l.2.2c.2.3.1.6-.1.8-.3.2-.6.2-.9-.1l-2-2-.1-.1c-.3.3-.5.5-.8.7.2.2.5.5.8.7.2.2.3.3.4.5.2.2.1.6-.1.8-.2.2-.5.2-.8.1-.1-.1-.2-.1-.2-.2l-1-1-.8.8s.1.1.2.1l1 1c.2.2.3.5.2.7-.2.4-.7.5-1 .1l-1-1-.1-.1-.9.9C3.5 15.8 4.7 17 6 18.3c4.2-4.3 8.5-8.6 12.8-12.8z" />
        </SvgIcon>
    );
}

SizeReco.defaultProps = {
    viewBox: '0 0 21 20'
};

export default SizeReco;
